import { render, staticRenderFns } from "./PortfolioMobile.vue?vue&type=template&id=28d56bae&scoped=true&"
import script from "./PortfolioMobile.vue?vue&type=script&lang=js&"
export * from "./PortfolioMobile.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioMobile.vue?vue&type=style&index=0&id=28d56bae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d56bae",
  null
  
)

export default component.exports